import React from "react";
import ServiceAdviceMessage from "duck/ui/chat/components/messages/ServiceAdviceMessage/ServiceAdviceMessage";
import {
  AssistantMessageContent,
  MessageType,
  ServiceAdviceData,
} from "duck/ui/chat/types";

import { Renderer } from "./types";

const hasServiceAdvice = (content: AssistantMessageContent): boolean =>
  content.message_type === MessageType.SUGGESTED_REPAIRS;

export const SuggestedRepairRenderer: Renderer<AssistantMessageContent> = {
  type: "suggested_repairs",

  canRender: (content: AssistantMessageContent): boolean =>
    hasServiceAdvice(content),

  render: (content: AssistantMessageContent): React.ReactNode => {
    if (!hasServiceAdvice(content)) return null;

    const service_advice = content as ServiceAdviceData;

    return <ServiceAdviceMessage parsedObject={service_advice} />;
  },
};
